/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesReferenceApplicationCountriesCountryResponse } from '../model/modulesReferenceApplicationCountriesCountryResponse';
import { ModulesReferenceApplicationStatesStateResponse } from '../model/modulesReferenceApplicationStatesStateResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ReferenceServiceInterface }                            from './reference.serviceInterface';


@Injectable()
export class ReferenceService implements ReferenceServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a list of Countries.
     * Retrieves all available Countries.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCountriesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesReferenceApplicationCountriesCountryResponse>>;
    public getCountriesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesReferenceApplicationCountriesCountryResponse>>>;
    public getCountriesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesReferenceApplicationCountriesCountryResponse>>>;
    public getCountriesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesReferenceApplicationCountriesCountryResponse>>('get',`${this.basePath}/reference/countries`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a list of States.
     * Retrieves all available States.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStatesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesReferenceApplicationStatesStateResponse>>;
    public getStatesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesReferenceApplicationStatesStateResponse>>>;
    public getStatesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesReferenceApplicationStatesStateResponse>>>;
    public getStatesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesReferenceApplicationStatesStateResponse>>('get',`${this.basePath}/reference/states`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
